import { Routes } from '@angular/router';
import { NewsComponent } from './news-section/news/news.component';
import { CourseDetailsCardComponent } from './_modules/golf/course-details-card/course-details-card.component';
import { GolfLeaderboardComponent } from './_modules/golf/golf-leaderboard/golf-leaderboard.component';
import { ChatDialogComponent } from './_dialogs/chat-dialog/chat-dialog.component';
import { WebviewSectionComponent } from './tournament-section/tournament/webview-section/webview-section.component';
import { GolfTeeTimesComponent } from './tournament-section/tournament/golf-tee-times/golf-tee-times.component';

// import { HomePageMetaData } from './_seo';

// const routes: Routes = [
//     { path: '', redirectTo: '/home', pathMatch: 'full' },
//     {
//         path: 'home', loadChildren: () => import('./home-section/home-section.module').then(m => m.HomeSectionModule),
//         data: HomePageMetaData
//     },
//     { path: 'tournament', loadChildren: () => import('./tournament-section/tournament-section.module').then(m => m.TournamentSectionModule) },
//     { path: 'ranking', loadChildren: () => import('./ranking-section/ranking-section.module').then(m => m.RankingSectionModule) },
//     { path: 'contributor/:article_id', loadChildren: () => import('./contributor-article-section/contributor-article-section.module').then(m => m.ContributorArticleSectionModule) },
//     { path: 'feed/:id', loadChildren: () => import('./feed-section/feed-section.module').then(m => m.FeedSectionModule) },
//     { path: 'feed/:subject_id/:subject_type', loadChildren: () => import('./feed-section/feed-section.module').then(m => m.FeedSectionModule) },
//     { path: 'articles', loadChildren: () => import('./news-section/news-section.module').then(m => m.NewsSectionModule) },
//     { path: 'articles/:subject_id/:subject_type', loadChildren: () => import('./contributor-article-section/contributor-article-section.module').then(m => m.ContributorArticleSectionModule) },
//     { path: 'table-scores/tournament/:id/:team_id', loadChildren: () => import('./_modules/golf-scorecard/golf-scorecard.module').then(m => m.GolfScorecardModule) },
//     // failover to home
//     { path: '**', redirectTo: '/home' },
//     // { path: 'event/:event_id', loadChildren: () => import('./event-section/event-section.module').then(m => m.EventSectionModule) },
//     // { path: 'login', loadChildren: () => import('./_modules/login/login.module').then(m => m.LoginModule) }
// ];

// @NgModule({
//     imports: [RouterModule.forRoot(routes)],
//     exports: [RouterModule]
// })
// export class AppRoutingModule { }

export const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    {
        path: 'home', loadComponent: () => import('./home-section/home-section.component').then(c => c.HomeSectionComponent)
    },
    { path: 'tournament', loadComponent: () => import('./tournament-section/tournament-section.component').then(c => c.TournamentSectionComponent) },
    {
        path: 'tournament/:team_id/:tournament_id', loadComponent: () => import('./tournament-section/tournament/tournament.component').then(c => c.TournamentComponent),
        children: [
            { path: '', component: CourseDetailsCardComponent },
            { path: 'tournament_details', component: CourseDetailsCardComponent },
            { path: 'leaderboard', component: GolfLeaderboardComponent },
            { path: 'tee_times', component: GolfTeeTimesComponent },
            { path: 'chat', component: ChatDialogComponent },
            { path: 'webview', component: WebviewSectionComponent }
        ]
    },

    { path: 'ranking', loadComponent: () => import('./ranking-section/ranking-section.component').then(c => c.RankingSectionComponent) },
    // { path: 'contributor/:article_id', loadChildren: () => import('./contributor-article-section/contributor-article-section.module').then(m => m.ContributorArticleSectionModule) },
    // { path: 'feed/:id', loadChildren: () => import('./feed-section/feed-section.module').then(m => m.FeedSectionModule) },
    // { path: 'feed/:subject_id/:subject_type', loadChildren: () => import('./feed-section/feed-section.module').then(m => m.FeedSectionModule) },
    // { path: 'articles/:subject_id/:subject_type', loadChildren: () => import('./contributor-article-section/contributor-article-section.module').then(m => m.ContributorArticleSectionModule) },
    // { path: 'table-scores/tournament/:id/:team_id', loadChildren: () => import('./_modules/golf-scorecard/golf-scorecard.module').then(m => m.GolfScorecardModule) },
    {
        path: 'articles',
        loadComponent: () => import('./news-section/news-section.component').then(c => c.NewsSectionComponent),
        children: [
            { path: '', component: NewsComponent },
            { path: 'all', component: NewsComponent },
            { path: 'news', component: NewsComponent },
            { path: 'videos', component: NewsComponent }
        ]
    },
    { path: 'articles/see-all/:timeline-id/:card-id', loadComponent: () => import('./news-section/see-all/see-all.component').then(c => c.SeeAllComponent) },
    { path: 'articles/contributor/:timeline-id/:card-id', loadComponent: () => import('./news-section/contributor-see-all/contributor-see-all.component').then(c => c.ContributorSeeAllComponent) },
    { path: '**', redirectTo: '/home' },
];
